const regionInfo = __REGION_CONFIG__[process.env.REGION_ENV];
export default regionInfo;
